import React from "react";
import { Box, Typography } from "@mui/material";
import NoQuoteIconSvg from "../../../../assets/svg-fc/NoQuoteIconSvg";
import CoreButtons from "../../../core-components/button/CoreButtons";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../../../../types/coreButtonTypes";
import "./quotesEmptyState.scss";

interface IQuotesEmptyStateProps {
	className?: string;
	message?: string;
	showAddNewQuoteButton?: boolean;
	onAddNewQuote?: () => void;
}

const QuotesEmptyState: React.FC<IQuotesEmptyStateProps> = ({
	className,
	onAddNewQuote,
	message,
	showAddNewQuoteButton = true,
}) => {
	return (
		<Box className={`quotesEmptyState ${className || ""}`}>
			<Box className="quotesEmptyContent">
				<Box className="emptyIconContainer">
					<NoQuoteIconSvg />
				</Box>
				<Typography className="emptyStateTitle">No quotes</Typography>
				<Typography className="emptyStateText">
					{message || "To send a quote for this event, simply click the 'Add new quote' button."}
				</Typography>
			</Box>
			{showAddNewQuoteButton && (
				<CoreButtons
					className="emptyStateButton"
					buttonText="Add new quote"
					variant={BUTTON_VARIANT.CONTAINED}
					color={BUTTON_COLOR.PRIMARY}
					fullWidth={false}
					coreBtnPill={true}
					onclick={onAddNewQuote}
				/>
			)}
		</Box>
	);
};

export default QuotesEmptyState;
